import * as React from 'react';
import { Button, TextField } from '../common';
import { Grid2 as Grid, InputLabel } from '@mui/material';

interface Props {
    readonly onSubmit: (username: string, password: string) => any;
}

interface State {
    readonly username: string;
    readonly password: string;
}

export class EmailLogin extends React.PureComponent<Props, State> {
    state = {
        username: '',
        password: '',
    };

    render() {
        const { username, password } = this.state;

        return (
            <Grid container={true} spacing={1}>
                <Grid size={12}>
                    <InputLabel style={{ color: 'white', fontWeight: 500 }}>Username</InputLabel>
                </Grid>
                <Grid size={12}>
                    <TextField
                        id="username"
                        label=""
                        value={username}
                        onChange={this.setUsername}
                        variant="outlined"
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                color: 'rgba(0,0,0,0.5)',
                                backgroundColor: '#fff',
                                boxShadow: 'rgb(224 224 224) 0px 0px 1px 1px !important',
                            }
                        }}
                    />
                </Grid>
                <Grid size={12}>
                    <InputLabel style={{ color: 'white', fontWeight: 500 }}>Password</InputLabel>
                </Grid>
                <Grid size={12}>
                    <TextField
                        id="password"
                        type="password"
                        label=""
                        value={password}
                        onChange={this.setPassword}
                        variant="outlined"
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                color: 'rgba(0,0,0,0.5)',
                                backgroundColor: '#fff',
                                boxShadow: 'rgb(224 224 224) 0px 0px 1px 1px !important',
                            }
                        }}
                    />
                </Grid>
                <Grid size={12}>
                    <Button
                        text="Log In"
                        variant="contained"
                        onClick={this.submit}
                        disabled={!this.validate()}
                        sx={{
                            marginLeft: 'auto',
                            '&.MuiButton-root': {
                                '&.Mui-disabled': {
                                    backgroundColor:'#f2f2f2',
                                    color: '#b8b8b8',
                                }
                            },
                            '&.MuiButton-contained': {
                                backgroundColor: '#e9eaeb',
                                color: 'rgba(0,0,0,0.5)',
                            }
                        }}
                    />
                </Grid>
            </Grid>
        );
    }

    private setUsername = (username: string) => this.setState({ username });

    private setPassword = (password: string) => this.setState({ password });

    private submit = () => this.validate() && this.props.onSubmit(this.state.username, this.state.password);

    private validate = () => this.state.username;
}
